module.exports = __webpack_public_path__ + "public/img/ico-charts-battery.197c74a1.svg";